import { render, staticRenderFns } from "./LabelContractsReadOnly.vue?vue&type=template&id=3c2f7e36"
import script from "./LabelContractsReadOnly.vue?vue&type=script&lang=js"
export * from "./LabelContractsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports